import { createAgnosticTypeSyncer } from '@wix/velo-site-types-syncer';
import { getNicknamesToComponentTypesMap } from '@wix/anyide-document-utils';
export const createIntellisenseAdapter = async (convertToOnlineLayoutCB, projectRootFolder) => {
    const agnosticTypesSyncer = await createAgnosticTypeSyncer(projectRootFolder, convertToOnlineLayoutCB);
    const processDocumentPages = async ({ pages }) => {
        const updatedPagesList = [];
        const deletedPagesList = [];
        for (const [pageId, pageData] of Object.entries(pages)) {
            if (pageData) {
                updatedPagesList.push({
                    id: pageId,
                    elements: await getNicknamesToComponentTypesMap(pageData.data)
                });
            }
            else {
                deletedPagesList.push({ id: pageId });
            }
        }
        return {
            updatedPagesList,
            deletedPagesList
        };
    };
    return {
        initTypes: async (document) => {
            const { updatedPagesList } = await processDocumentPages(document);
            await agnosticTypesSyncer.syncSite({ offlinePages: updatedPagesList });
        },
        updateTypes: async (document) => {
            const { updatedPagesList, deletedPagesList } = await processDocumentPages(document);
            if (updatedPagesList.length > 0) {
                await agnosticTypesSyncer.syncPages(updatedPagesList);
            }
            if (deletedPagesList.length > 0) {
                await agnosticTypesSyncer.deletePages(deletedPagesList);
            }
        }
    };
};
